/* Decorations Container - Desktop background layer */
.decorationsContainer {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
  z-index: 0;
}

/* === PARTICLES === */
.particlesContainer {
  position: absolute;
  inset: 0;
}

.particle {
  position: absolute;
  background: var(--color-accent-primary);
  border-radius: 50%;
  opacity: 0.35;
  animation: particleFloat 10s ease-in-out infinite;
}

.particle:nth-child(odd) {
  background: var(--color-accent-secondary);
  animation-direction: reverse;
}

.particle:nth-child(3n) {
  border-radius: 2px;
  transform: rotate(45deg);
}

/* === AMBIENT LIGHT === */
.ambientLight {
  position: absolute;
  inset: 0;
  overflow: hidden;
}

.lightOrb {
  position: absolute;
  width: 700px;
  height: 700px;
  border-radius: 50%;
  filter: blur(120px);
  opacity: 0.12;
  animation: lightPulse 8s ease-in-out infinite;
}

.lightOrb[data-position="top-left"] {
  top: -200px;
  left: -200px;
  background: var(--color-accent-primary);
  animation-delay: 0s;
}

.lightOrb[data-position="bottom-right"] {
  bottom: -200px;
  right: -200px;
  background: var(--color-accent-secondary);
  animation-delay: -4s;
}

.lightOrb[data-position="center"] {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  height: 500px;
  background: var(--color-accent-primary);
  opacity: 0.06;
  animation-delay: -2s;
  animation-duration: 12s;
}

/* === GRID OVERLAY === */
.gridOverlay {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(
      to right,
      var(--color-border-subtle) 1px,
      transparent 1px
    ),
    linear-gradient(
      to bottom,
      var(--color-border-subtle) 1px,
      transparent 1px
    );
  background-size: 80px 80px;
  opacity: 0.15;
  mask-image: radial-gradient(
    ellipse 80% 60% at 50% 50%,
    black 0%,
    transparent 70%
  );
}

/* === ANIMATIONS === */
@keyframes particleFloat {
  0%, 100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.3;
  }
  25% {
    transform: translate(20px, -30px) scale(1.2);
    opacity: 0.55;
  }
  50% {
    transform: translate(-12px, -45px) scale(0.85);
    opacity: 0.2;
  }
  75% {
    transform: translate(-25px, -18px) scale(1.1);
    opacity: 0.45;
  }
}

@keyframes lightPulse {
  0%, 100% {
    opacity: 0.08;
    transform: scale(1);
  }
  50% {
    opacity: 0.18;
    transform: scale(1.15);
  }
}

/* === REDUCED MOTION === */
@media (prefers-reduced-motion: reduce) {
  .particle,
  .lightOrb {
    animation: none;
  }

  .decorationsContainer {
    opacity: 0.5;
  }
}

/* === DARK THEME ADJUSTMENTS === */
[data-theme="dark"] .gridOverlay {
  opacity: 0.08;
}

[data-theme="dark"] .lightOrb {
  opacity: 0.18;
}

[data-theme="dark"] .particle {
  opacity: 0.45;
}
